import type { ViewerLocale } from "./viewerPreferences";

export function buildArtistHubPath(locale: ViewerLocale): `/${ViewerLocale}/artists` {
  return `/${locale}/artists`;
}
